import { Box, Typography, Link } from '@mui/material';
import HuntingtonLogo from '../../assets/Huntington_Primary_Logo_Horizontal_RGB_Off_White 1.png';
import { useSelector } from 'react-redux';
import { selectIsPrivateLabel } from '../../redux/slices/uiSettingsSlice';

function LoginFooter() {
  const isPrivateLabel = useSelector(selectIsPrivateLabel);
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 2,
        px: { xs: 2, sm: 6 },
        backgroundColor: (theme) => theme.palette.primary.main,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 2, sm: 0 },
        borderTop: (theme) => (`4px solid ${theme.palette.secondary.main}`)
      }}
    >
      {/* Left Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 0 } }}>
        {!isPrivateLabel && (
          <Box component="img" src={HuntingtonLogo} alt="Huntington Logo" sx={{ height: 32, mr: 2 }} />
        )}
        <Typography variant="body2" color="white" sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
          {isPrivateLabel
            ? 'Powered by Huntington Bancshares Incorporated.'
            : `© ${new Date().getFullYear()} Huntington Bancshares Incorporated.`}
        </Typography>
      </Box>
      {/* Right Section: Footer Links */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 1, sm: 3 },
        }}
      >
        <Link href="#" color="inherit" underline="hover" sx={{ fontSize: 14, color: 'surface.primary' }}>
          Privacy Policy
        </Link>
        <Link href="#" color="inherit" underline="hover" sx={{ fontSize: 14, color: 'surface.primary' }}>
          Terms of Service
        </Link>
        <Link href="#" color="inherit" underline="hover" sx={{ fontSize: 14, color: 'surface.primary' }}>
          Contact
        </Link>
      </Box>
    </Box>
  );
}

export default LoginFooter;
